const POSSIBLE_EM_NAMES = [
    'EM_proceedwithcaution',
    'EM_specialguidancerequired',
    'EM_furtherconsultationrequired',
    'EM_permissionrequired'
];

export const ABSOLUTE_URL_REGEX = /(https?:\/\/[^\s]+|www\.[^\s]+|[\w-]+\.[\w-]+\.[\w.]+)/g;

const formatUrlFallback = (value) => {
    const withoutTrailingSlash = value.replace(/\/+$/, '');
    const [firstSegment = ''] = withoutTrailingSlash.split('/');
    const hostLikeValue = firstSegment.replace(/^[A-Za-z][A-Za-z\d+.-]*:\/\//, '').replace(/^www\./i, '');

    return hostLikeValue
        .replace(/[-_]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/^[A-Za-z]/, (match) => match.toUpperCase());
};

export const isLikelyUrl = (value) => {
    /*
    * Broadly, we autodetect links if they
    *
    * 1) start with http:// or https://
    * 2) start with www.
    * 3) end with .co.uk
    * */
    if (typeof value !== 'string') {
        return false;
    }

    const trimmed = value.trim();
    if (!trimmed) {
        return false;
    }

    const shouldPrefix = trimmed.startsWith('www.') || trimmed.match(/^[A-Za-z0-9-]+\.co.uk$/);
    const candidate = shouldPrefix ? `https://${trimmed}` : trimmed;

    try {
        const url = new URL(candidate);
        return url.protocol === 'http:' || url.protocol === 'https:';
    } catch {
        return false;
    }
};

export const prettifyUrl = (url, name) => {
    if (typeof url !== 'string') {
        return '';
    }

    const trimmed = url.trim();
    if (!trimmed) {
        return '';
    }

    if (name && !POSSIBLE_EM_NAMES.includes(name)) {
        // I dont think we'll ever reach here...
        return name;
    }

    const candidate = trimmed.match(/^[A-Za-z][A-Za-z\d+.-]*:\/\//) ? trimmed : `https://${trimmed}`;

    try {
        const hostname = new URL(candidate).hostname.replace(/^www\./i, '').toLowerCase();

        if (hostname.includes('.')) {
            return hostname;
        }
    } catch {
        // Fall through to the legacy formatter when the value is not a usable URL.
    }

    return formatUrlFallback(trimmed);
};

export const addProtocolToUrl = (url) => {
    if (url.match(/^https?:\/\//)) {
        return url;
    }
    return `https://${url}`;
};
